import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, of as observableOf } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { MODULE_LEGAL_DOCUMENT_PAGE } from '@app/core/mixpanel.constants';
import { StepName } from '@app/registration/enterprise/registration-step-name';

import { RegistrationService } from '../../registration.service';
import { EnterpriseRegistration } from '../enterprise-registration';
import { EnterpriseRegistrationAnalyticsService } from '../enterprise-registration-analytics.service';
import { RegistrationStep } from '../registration-step';
import { TermsOfServiceStepComponent } from './terms-of-service-step.component';

@Injectable()
export class TermsOfServiceConfig extends RegistrationStep {
  GA_LABEL = 'ToS_Step';
  MODULE = MODULE_LEGAL_DOCUMENT_PAGE;

  component = TermsOfServiceStepComponent;
  componentInstance: TermsOfServiceStepComponent;
  progress = 70;
  form: UntypedFormGroup = null;

  constructor(
    private registrationService: RegistrationService,
    private enterpriseRegistrationAnalyticsService: EnterpriseRegistrationAnalyticsService,
  ) {
    super();
  }

  initComponent(component: TermsOfServiceStepComponent, state: EnterpriseRegistration) {
    component.user = state.patient;
    component.signer = state.patient;
    this.componentInstance = component;
  }

  submit(state: EnterpriseRegistration): Observable<any> {
    return this.registrationService.markRegComplete().pipe(
      take(1),
      map(() => {
        this.enterpriseRegistrationAnalyticsService.regInputSubmitted({
          module: this.MODULE,
          isWhitelist: state.isWhitelisted,
          relationshipType: state.details.membershipType,
        });
        state.setCurrentStep(StepName.mfa);
        return observableOf(true);
      }),
    );
  }
}
